/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const EmptyIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="-1 -1 65 65"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  />
);

export default EmptyIcon;
